import { API } from '@ax/api';
import { API_SERVICES } from './utils.tsx';
import { DeleteMacroInput, MacrosInput } from './macros-interface.ts';

export const getTemplates = async (providerId: string, section: string): Promise<any> => {
  const res = await API.post(API_SERVICES.MACROS_API, `/api/search`, {
    params: {
      providerId,
      type: 'PROVIDER',
    },
    data: {
      attributes: [
        {
          key: 'note_section',
          value: section,
        },
      ],
    },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};

export const saveTemplate = async (data: MacrosInput) => {
  const res = await API.post(API_SERVICES.MACROS_API, `/api`, {
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};

export const updateTemplate = async (data: MacrosInput) => {
  const res = await API.put(API_SERVICES.MACROS_API, `/api`, {
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};

export const deleteTemplate = async (data: DeleteMacroInput) => {
  const res = await API.delete(API_SERVICES.MACROS_API, `/api/${data.macroId}`, {
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};
